export default "__VITE_ASSET__CHrxC6Y0__"